import React from "react";
import OrderListCommonLayer from "./OrderListCommonLayer";

const PaidOrdersLayer = () => {
    return (
        <OrderListCommonLayer 
            pageTitle="Paid Orders" 
            categoryStatus="" 
            categoryPayStatus="Paid" 
        />
    );
};

export default PaidOrdersLayer;
